<template>
  <div class="activitie-box">
    <div class="activitie-head"></div>
    <div class="activitie-main">
      <div class="activitie-one bgtagm">
        <div class="list-title">每日里程王</div>
        <div class="list-tag">
          <template v-if="everydayMileageUsers.length === 1 || everydayMileageUsers.length === 0">
            <van-row class="list-row text-color">
              <van-col class="list-item" span="8">暂无数据</van-col>
              <van-col class="list-item" span="8">暂无数据</van-col>
              <van-col class="list-item text-right" span="8">暂无数据</van-col>
            </van-row>
          </template>
          <template v-for="(item, key) in everydayMileageUsers">
            <template v-if="key < everydayMileageUsers.length - 1">
              <van-row :key="key" :class="key <= 2 ? 'list-row text-color' : 'list-row'">
                <van-col class="list-item" span="7">{{key + 1}}.{{item.nickname}}</van-col>
                <van-col class="list-item" span="7">{{item.createAt.split(' ')[0]}}</van-col>
                <van-col class="list-item text-right" span="10">里程：{{item.totalMileage.toFixed(2)}} km</van-col>
              </van-row>
            </template>
            <template v-if="key === everydayMileageUsers.length - 1">
              <template v-if="item.rank !== 0">
                <div :key="key" class="list-self">您的当前排名第 {{item.rank}}名    里程：{{item.totalMileage.toFixed(2)}}km/h</div>
              </template>
              <template v-else>
                <div :key="key" class="list-self">您未上榜</div>
              </template>
            </template>
          </template>
        </div>
      </div>
      <div class="activitie-one bgtags">
        <div class="list-title">幸运里程排行榜</div>
        <div class="list-tag">
          <template v-for="(item, key) in lucklyUsers">
            <template v-if="key < lucklyUsers.length">
              <van-row :key="key" class="list-row text-color">
                <van-col class="list-item" span="7">{{key + 1}}.{{item.nickname}}</van-col>
                <van-col class="list-item" span="6">{{item.createAt}}</van-col>
                <van-col class="list-item" span="11">率先突破里程：{{item.mileage}}km</van-col>
              </van-row>
            </template>
          </template>
          <template v-if="lucklyUsers.length === 0">
            <van-row class="list-row text-color">
              <van-col class="list-item" span="8">暂无数据</van-col>
              <van-col class="list-item" span="8">暂无数据</van-col>
              <van-col class="list-item" span="8">暂无数据</van-col>
            </van-row>
          </template>
        </div>
      </div>
      <div class="activitie-explain">
        以上所有奖项的奖品将于2019年2月21日之后统一安排寄送，中奖名单敬请留意摩征APP，更多奖项内容详请关注比亚乔机车微信公众号
      </div>
      <div class="activitie-footer">
        <div class="activitie-tips">此次大赛的活动解释权归宗申•比亚乔佛山摩托车企业有限公司所有</div>
        <div class="activitie-logo"><img src="../../assets/images/logo.png"></div>
      </div>
    </div>
    <div class="activitie-foot"></div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Row, Col } from 'vant'
import { getActivitiesList } from 'api/activities'
Vue.use(Row).use(Col)
export default {
  name: 'ActivitiesMatch',
  data () {
    return {
      tokenapi: '',
      everydayMileageUsers: [],
      lucklyUsers: [],
      totalMileageUsers: [],
      token: ''
    }
  },
  created () {
    this.token = window._native_.getToken()
    // this.getList()
  },
  watch: {
    token: function (newVal, oldVal) {
      this.getList()
    }
  },
  methods: {
    getList () {
      const KeyAip = this.token
      getActivitiesList(KeyAip).then((res) => {
        console.log(res.data)
        const datas = res.data
        if (datas.error === '') {
          this.everydayMileageUsers = datas.data[0].everydayMileageUsers
          this.lucklyUsers = datas.data[0].lucklyUsers
          // this.totalMileageUsers = datas.data[0].totalMileageUsers
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@colorText:#43dff3;
@colorWhite:#ffffff;
@fontnomal:12px;
@fonttitle:15px;
.bgimg2{
  background: url('../../assets/images/tag2.png');
  background-size: 100% 100%;
  background-position: center;
}
.bgmainl{
  background: url('../../assets/images/tagmainl.png');
  background-size: 100% 100%;
  background-position: center;
}
.bgmainm{
  background: url('../../assets/images/tagmainm.png');
  background-size: 100% 100%;
  background-position: center;
}
.bgtitle{
  background: url('../../assets/images/tagtitle.png');
  background-size: 100% 100%;
  background-position: center;
}
.text-right{
  padding-left: 20px;
}
.text-color{
  color: @colorText !important;
}
html,body,#app{
  height: 100%;
  width: 100%;
}
.activitie{
  &-box{
    min-height: 100%;
    background: url('../../assets/images/boxbg.png');
    background-size: 100% 100%;
    background-position: center;
    font-family: '微软雅黑';
  }
  &-head{
    height: 240px;
    width: 100%;
  }
  &-foot{
    height: 25px;
    width: 100%;
  }
  &-main{
    .activitie{
      &-one{
        position: relative;
        &.bgtags{
          margin-left: 23px;
          margin-right: 23px;
          margin-bottom: 35px;
          .list-tag{
            padding-top: 36px;
            .bgmainm;
            padding-left: 15px;
            padding-right: 15px;
          }
        }
        &.bgtagm{
          margin-left: 23px;
          margin-right: 23px;
          margin-bottom: 45px;
          .list-tag{
            padding-top: 36px;
            .bgmainl;
            min-height: 170px;
          }
          .text-right{
            padding-left: 0px;
          }
        }
        &.rules{
          .list-title{
            height: 35px;
            line-height: 35px;
            margin-top: 0;
          }
          .list-tag{
            padding-bottom: 15px;
          }
        }
        .list-title{
          position: absolute;
          top: -30px;
          left: 0;
          width: 100%;
          height: 66px;
          line-height: 66px;
          font-size: @fonttitle;
          font-weight: bold;
          color: @colorText;
          text-align: center;
          .bgtitle;
          z-index: 2;
        }
        .list-tag{
          position: relative;
          min-height: 100px;
          padding: 0px 20px;
        }
        .list-row{
          font-size: @fontnomal;
          color: @colorWhite;
          .list-item{
            margin-bottom: 10px;
            &:last-child{
              margin-bottom: 0px;
            }
          }
        }
        .list-self{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          color: @colorText;
          font-size: @fontnomal;
          margin-bottom: 15px;
          text-align: center;
        }
        .list-rule{
          font-size: @fontnomal;
          color: @colorText;
          line-height: 18px;
        }
      }
      &-explain{
        position: relative;
        .bgimg2;
        padding: 20px;
        margin: 0px 22px 20px 22px;
        color: @colorText;
        font-size: @fontnomal;
      }
      &-footer{
        padding-top: 22px;
      }
      &-tips{
        width: 100%;
        font-size: 10px;;
        color: @colorText;
        text-align: center;
        -webkit-transform:scale(0.85);
      }
      &-logo{
        text-align: center;
        margin-top: 10px;
        img{
          height: 26px;
          width: auto;
        }
      }
    }
  }
}
</style>
